import {atom} from "jotai";
import {
  AdmUserNotificationsApi$LatestNotification,
} from "@/custolink-transpiled_by_server/bc.identity_and_access.api_methods";

export type AdminAreaNotifications = {
  latest10 : AdmUserNotificationsApi$LatestNotification[]
}

export const adminAreaNotifications = atom<AdminAreaNotifications>({
  latest10: []
})


